function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Skeleton({ className }) {
  return (
    <div
      className={classNames(
        'animate-pulse rounded-md bg-gray-200',
        className
      )}
    />
  );
}